module.exports = __webpack_public_path__ + "static/media/404.2b1b80cd.jpeg";